var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAxiosLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      isolation: "isolate"
    },
    viewBox: "0 0 512 512",
    width: "512px",
    height: "512px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clipPath_NWa79UF1oiJ7AbotQ4awtGre8CFiNeNw"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clipPath_NWa79UF1oiJ7AbotQ4awtGre8CFiNeNw)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: " M 96 304 L 96 336 L 32 272 L 96 272 L 336 272 L 368 304 L 96 304 Z ",
    fill: "#764ABC"
  }), /*#__PURE__*/React.createElement("path", {
    d: " M 416 208 L 416 176 L 480 240 L 416 240 L 176 240 L 144 208 L 416 208 Z ",
    fill: "#764ABC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAxiosLogo);
export default __webpack_public_path__ + "static/media/axios_logo.4b938d3fab6a6f55afb82d7929f371a9.svg";
export { ForwardRef as ReactComponent };